/**
 * Run async function in safe mode
 * @param {function} func
 * @return {Promise<*>}
 */
export const runSafely = async (func) => {
  try {
    return await func();
  } catch (error) {}
};
